import { useEffect, useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { auth, db } from '../Firebase_Config/firebase';
import { NavLink } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import './PrivacyMeter.css';

const GET_EMAIL = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState('success');
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userDocQuery = query(collection(db, 'users'), where('userId', '==', user.uid));
      const userDocSnapshot = await getDocs(userDocQuery);

      if (!userDocSnapshot.empty) {
        const userData = userDocSnapshot.docs[0].data();
        setFormData(prev => ({
          ...prev,
          name: userData.Name || '',
          email: userData.email || ''
        }));
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, message: e.target.value });
  };

  const showToast = (message, severity = 'success') => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const handleCloseToast = (_, reason) => {
    if (reason === 'clickaway') return;
    setToastOpen(false);
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const formDataToSend = {
      ...formData,
      access_key: "eeb7e415-06eb-495c-a9f8-075545b91e36"
    };

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(formDataToSend)
    }).then((res) => res.json());

    if (res.success) {
      showToast("Email submitted successfully!", "success");
      setFormData(prev => ({ ...prev, message: '' }));
    } else {
      showToast("Failed to submit. Please try again.", "error");
    }
  };

  return (
    <div className="ContactContainer">
      <h1 className='helptitle'>Contact Form</h1>
      <br/>
      <div className='Hom-card-accent'/>
      
      <form onSubmit={onSubmit}>
        <textarea
          className='OtherInputs'
          name="message"
          placeholder="Write Your Message Here.."
          value={formData.message}
          onChange={handleChange}
        />
        <button className='SubmitInput' type="submit">Submit Form</button>
      </form>

      <Snackbar open={toastOpen} autoHideDuration={4000} onClose={handleCloseToast} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <MuiAlert onClose={handleCloseToast} severity={toastSeverity} sx={{ width: '100%' }} elevation={6} variant="filled">
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

  const PrivacyMeter = () => {
    const [showModal, setShowModal] = useState(true);
    const [hasPaidTrue, setHasPaidTrue] = useState(null);
    const [showContactModal, setShowContactModal] = useState(false);
    
    const getUserId = () => {
      const user = auth.currentUser;
      return user?.uid;
    };
  
    const fetchHasPaidTrue = async () => {
      try {
        const userId = getUserId();
        if (!userId) return;
  
        const userDocQuery = query(collection(db, 'users'), where('userId', '==', userId));
        const userDocSnapshot = await getDocs(userDocQuery);
  
        if (!userDocSnapshot.empty) {
          const userDocData = userDocSnapshot.docs[0].data();
          const getHasPaid = userDocData.HasPaid || false;
          setHasPaidTrue(getHasPaid);
        } else {
          console.log('User document not found');
          setHasPaidTrue(false); // default to false if not found
        }
      } catch (error) {
        console.error('Error fetching payment status:', error);
        setHasPaidTrue(false);
      }
    };
  
    useEffect(() => {
      fetchHasPaidTrue();
    });
  
    const isDisabled = hasPaidTrue === false;

    const handleContactClick = () => {
      setShowModal(false);
      setShowContactModal(true);
    };

  return (
    <div className='PrivBG'>
      {hasPaidTrue === false && showModal && (
        <div className="Ai-modal-overlay">
          <div className="paid-modal-content">
            <button className="close-button" onClick={() => setShowModal(false)}>×</button>
             <button className="contact-button" onClick={handleContactClick}>Contact Us To Get Access</button>
          </div>
        </div>
      )}

      {showContactModal && (
        <div className="Ai-modal-overlay">
          <div className="paid-modal-content contact">
            <button className="close-button" onClick={() => setShowContactModal(false)}>×</button>
            <GET_EMAIL />
          </div>
        </div>
      )}
      <div className='Privcontent'>
        <div className='Priv-container'>
          <div className='Priv-card-accent'/>
          <br/>
          <img src="PrivacyMeter.png" alt="Logo" className='Priv-image' />
          <div className='PrivtextContent'>
            <div className='Privcontainer'>
              <div className='Priv2'>
                <div className='Privcolumns'>
                  <h2>What is Privacy Meter?</h2>
                  <p>Privacy Meter is a library to audit data privacy in a wide range of statistical and machine learning algorithms (classification, regression, computer vision, and natural language processing). The tool enables data protection impact assessment based on the state-of-the-art membership inference attacks.</p>
                  <h2>Why Privacy Meter?</h2>
                  <p>Machine learning is playing a central role in automated decision-making in a wide range of organizations and service providers. The data, which are used to train the models, typically contain sensitive information about individuals. Although the data in most cases cannot be released, due to privacy concerns, the models are usually made public or deployed as a service for inference on new test data. For a safe and secure use of machine learning models, it is important to have a quantitative assessment of the privacy risks of these models, and to make sure that they do not reveal sensitive information about their training data. This is of great importance as there has been a surge in the use of machine learning in sensitive domains such as medical and finance applications.</p>
                </div>
                <div className='Privcolumns'>
                  <h2>Regulatory Compliance</h2>
                  <p>Data Protection regulations, such as GDPR and AI governance frameworks, require personal data to be protected when used in AI systems, and that the users have control over their data and awareness about how it is being used. For example, Article 35 of GDPR requires organisations to systematically analyse, identify and minimise the data protection risks of a project, especially when the project involves innovative technologies such as Artificial Intelligence, Machine Learning, and Deep Learning. Thus, proper mechanisms need to be in place to quantitatively evaluate and verify the privacy of individuals in every step of the data processing pipeline in AI systems.</p>
                  <b>Overview</b>
                  <p>Privacy Meter supports different types of models, datasets and privacy games, which all need to be specified in a .yaml configuration file.</p>
                  <img src="PrivacyDia.png" alt="Logo" className='Priv-image2' />
                </div>
              </div>
              <br/>
              {/*<p className='textCenterBold'>This repository contains demos and implementations for auditing privacy risks in machine learning models using the Privacy Meter library. It includes Jupyter notebook demonstrations and configuration files for various membership inference attack scenarios.</p>
               {hasPaidTrue && (
                <div className='button-group'>
                  <a href="https://github.com/idattani/Privacy-Meter" target="_blank">
                      <button className="download-button" disabled={isDisabled}>Privacy Meter Github</button>
                  </a>
                </div>
              )} */}
              <div className='button-group'>
                <NavLink 
                  to="/ContactUs" 
                >
                  <button className='download-button' >Contact Us</button>
                </NavLink>
              </div>
            </div>            
          </div>        
        </div>
      </div>
    </div>
  );
};

export default PrivacyMeter;
